import { render } from "./TemplateBlocksList.vue?vue&type=template&id=2db3d551&scoped=true"
import script from "./TemplateBlocksList.vue?vue&type=script&lang=js"
export * from "./TemplateBlocksList.vue?vue&type=script&lang=js"

import "./TemplateBlocksList.vue?vue&type=style&index=0&id=2db3d551&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db3d551"]])

export default __exports__